/**
 * Client-side tracking helper for VSKR Legal.
 *
 * SERVER_FIRST / MONGO_AUTHORITATIVE: this file ONLY sends events to the backend.
 * No activity data, logs, sessions or history are ever stored in the browser.
 * The only browser storage used here is an anonymous identifier (visitor_id /
 * session_id) purely so the server can correlate events.
 */
const API_URL = process.env.REACT_APP_BACKEND_URL;

const VISITOR_KEY = 'vskr_visitor_id';
const SESSION_KEY = 'vskr_session_id';

const genId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};

export const getVisitorId = () => {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = genId();
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
};

// Session id lives in sessionStorage so a new browser session starts a new server session.
export const getSessionId = () => {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = genId();
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
};

const getToken = () => localStorage.getItem('vskr_token');

/**
 * Send a generic event to the server-side ingest endpoint.
 * Future modules (search, documents, research, AI usage, etc.) can call this
 * with their own event_type and metadata.
 */
export const trackEvent = async (eventType = 'page_view', { path, metadata } = {}) => {
  try {
    const headers = { 'Content-Type': 'application/json' };
    const token = getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;

    await fetch(`${API_URL}/api/track/event`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        visitor_id: getVisitorId(),
        session_id: getSessionId(),
        event_type: eventType,
        path: path || window.location.pathname,
        referrer: document.referrer || null,
        metadata: metadata || {},
      }),
      keepalive: true,
    });
  } catch (e) {
    // Tracking must never break the app.
  }
};
